import React from "react";
import { Box, Button, MenuItem, TextField } from "@mui/material";
import { alpha, useTheme } from "@mui/material/styles";
import ClearAllIcon from "@mui/icons-material/ClearAll";

const BN_YELLOW = "#F0B90B";

export default function FiltersBar({
  filters,
  setFilters,
  pairs,
  showDates = false,
  onClear,
}) {
  const theme = useTheme();
  const borderCol = alpha(theme.palette.divider, 0.6);

  return (
    <Box
      sx={{
        mb: 1,
        display: "grid",
        gap: 1,
        gridTemplateColumns: {
          xs: "repeat(2, minmax(0,1fr))",
          sm: "repeat(3, minmax(0,1fr))",
          md: showDates
            ? "repeat(8, minmax(0,1fr))"
            : "repeat(6, minmax(0,1fr))",
        },
        alignItems: "center",
      }}
    >
      <TextField
        select
        size="small"
        label="Pair"
        fullWidth
        value={filters.pair}
        onChange={(e) => setFilters((f) => ({ ...f, pair: e.target.value }))}
        sx={{
          "& .MuiOutlinedInput-root": {
            borderRadius: 2,
            "& fieldset": { borderColor: borderCol },
            "&:hover fieldset": { borderColor: alpha(BN_YELLOW, 0.7) },
            "&.Mui-focused fieldset": { borderColor: BN_YELLOW },
          },
        }}
      >
        {pairs.map((p) => (
          <MenuItem key={p} value={p}>
            {p}
          </MenuItem>
        ))}
      </TextField>

      <TextField
        select
        size="small"
        label="Position"
        fullWidth
        value={filters.position}
        onChange={(e) =>
          setFilters((f) => ({ ...f, position: e.target.value }))
        }
      >
        {["ALL", "Long", "Short"].map((v) => (
          <MenuItem key={v} value={v}>
            {v}
          </MenuItem>
        ))}
      </TextField>

      <TextField
        select
        size="small"
        label="Margin"
        fullWidth
        value={filters.margin}
        onChange={(e) => setFilters((f) => ({ ...f, margin: e.target.value }))}
      >
        {["ALL", "Cross", "Isolated"].map((v) => (
          <MenuItem key={v} value={v}>
            {v}
          </MenuItem>
        ))}
      </TextField>

      <TextField
        select
        size="small"
        label="Type"
        fullWidth
        value={filters.type}
        onChange={(e) => setFilters((f) => ({ ...f, type: e.target.value }))}
      >
        {["ALL", "Market", "Limit"].map((v) => (
          <MenuItem key={v} value={v}>
            {v}
          </MenuItem>
        ))}
      </TextField>

      <TextField
        select
        size="small"
        label="Status"
        fullWidth
        value={filters.status}
        onChange={(e) => setFilters((f) => ({ ...f, status: e.target.value }))}
      >
        {["ALL", "Filled", "Closed", "Canceled", "Cancelled", "Liquidated"].map(
          (v) => (
            <MenuItem key={v} value={v}>
              {v}
            </MenuItem>
          )
        )}
      </TextField>

      <TextField
        size="small"
        label="Search"
        placeholder="symbol / id / status …"
        fullWidth
        value={filters.q}
        onChange={(e) => setFilters((f) => ({ ...f, q: e.target.value }))}
      />

      {showDates && (
        <>
          <TextField
            size="small"
            label="From"
            type="date"
            fullWidth
            value={filters.from}
            onChange={(e) =>
              setFilters((f) => ({ ...f, from: e.target.value }))
            }
            InputLabelProps={{ shrink: true }}
          />
          <TextField
            size="small"
            label="To"
            type="date"
            fullWidth
            value={filters.to}
            onChange={(e) => setFilters((f) => ({ ...f, to: e.target.value }))}
            InputLabelProps={{ shrink: true }}
          />
        </>
      )}

      <Box
        sx={{
          display: "flex",
          gap: 1,
          gridColumn: { xs: "1 / -1", md: "auto" },
        }}
      >
        <Button
          onClick={onClear}
          startIcon={<ClearAllIcon />}
          variant="outlined"
          fullWidth
          sx={{
            borderRadius: 2,
            fontWeight: 800,
            borderColor: alpha(BN_YELLOW, 0.6),
            "&:hover": {
              borderColor: BN_YELLOW,
              background: alpha(BN_YELLOW, 0.12),
            },
          }}
        >
          Clear
        </Button>
      </Box>
    </Box>
  );
}
